// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import Enums from '../Enums';

export class MonthlyForecastAgg {
  readonly year: string;
  readonly month: string;
  readonly totalProject: string;
  readonly totalProjectUnit: Enums.Unit;
  readonly budget: string;
  readonly budgetUnit: Enums.Unit;
  readonly capacity: string;
  readonly capacityUnit: Enums.Unit;

  constructor(data: { [key: string]: any } = {}) {
    this.year = data.year === undefined ? '' : data.year;
    this.month = data.month === undefined ? '' : data.month;
    this.totalProject = data.totalProject === undefined ? '0' : data.totalProject;
    this.totalProjectUnit =
      data.totalProjectUnit === undefined ? Enums.Unit.CuYd : data.totalProjectUnit;
    this.budget = data.budget === undefined ? '0' : data.budget;
    this.budgetUnit = data.budgetUnit === undefined ? Enums.Unit.CuYd : data.budgetUnit;
    this.capacity = data.capacity === undefined ? '0' : data.capacity;
    this.capacityUnit = data.capacityUnit === undefined ? Enums.Unit.CuYd : data.capacityUnit;
  }

  static zero(): MonthlyForecastAgg {
    const zeroValues: ExcludeMethodsDeep<MonthlyForecastAgg> = {
      year: '',
      month: '',
      totalProject: '0',
      totalProjectUnit: Enums.Unit.CuYd,
      budget: '0',
      budgetUnit: Enums.Unit.CuYd,
      capacity: '0',
      capacityUnit: Enums.Unit.CuYd,
    };
    return new MonthlyForecastAgg(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type MonthlyForecastAggWireFormat = {
  year: string;
  month: string;
  totalProject: string;
  totalProjectUnit: string;
  budget: string;
  budgetUnit: string;
  capacity: string;
  capacityUnit: string;
};

type NewMonthlyForecastAggProps = PartialDeep<MonthlyForecastAgg, { recurseIntoArrays: true }>;
export const NewMonthlyForecastAgg: (props: NewMonthlyForecastAggProps) => MonthlyForecastAgg = (
  props,
) => new MonthlyForecastAgg(props);

type NewMonthlyForecastAggFromWireFormatProps = PartialDeep<
  MonthlyForecastAggWireFormat,
  { recurseIntoArrays: true }
>;
export const NewMonthlyForecastAggFromWireFormat: (
  props: NewMonthlyForecastAggFromWireFormatProps,
) => MonthlyForecastAgg = (props) => new MonthlyForecastAgg(props);
